export default {"src":"/_next/static/media/super-pro-badge.d8eca4e4.svg","height":19,"width":19,"blurWidth":0,"blurHeight":0};